var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Base } from '@stepstone-genesis/components';
import { isFunction } from '../../utils/helpers/helpers';
export var FileInputButton = function (_a) {
    var accept = _a.accept, dataAt = _a.dataAt, _b = _a.label, label = _b === void 0 ? 'default label' : _b, _c = _a.renderButton, renderButton = _c === void 0 ? null : _c, fileListHandler = _a.fileListHandler, rest = __rest(_a, ["accept", "dataAt", "label", "renderButton", "fileListHandler"]);
    var inputRef = useRef();
    var triggerFileInput = function () {
        var _a;
        if (inputRef.current) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    var createOnFileInputChangeHandler = function (callbackFn) {
        return function (event) {
            var _a, _b;
            var fileList = [];
            for (var i = 0; i < ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files.length); i++) {
                fileList.push((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.files.item(i));
            }
            if (!fileList.length)
                return;
            inputRef.current.value = '';
            return isFunction(callbackFn) ? callbackFn(fileList, event) : event;
        };
    };
    var onFileInputChange = createOnFileInputChangeHandler(fileListHandler);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", __assign({ accept: accept, "data-at": "".concat(dataAt, "-upload-area-input"), style: { display: 'none' }, onChange: onFileInputChange, ref: inputRef, type: 'file' }, rest)),
        React.createElement(Base, { onClick: triggerFileInput, sx: {
                display: 'block',
                width: '100%',
            } }, renderButton ? renderButton : React.createElement("button", null, label))));
};
//# sourceMappingURL=index.js.map